import { useNavigate } from "react-router-dom";

import type { Project } from "@apis/memory/models";

import { router } from "../../bootstrap/router.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useAppNavigation() {
  const navigate = useNavigate();

  return {
    goToDashboard: (): void => {
      navigate(router.getUrl("Dashboard"));
    },
    goToGithubConnections: (): void => {
      navigate(router.getUrl("GithubConnections"));
    },
    goToMemoryProject: (projectId: Project["id"]): void => {
      navigate(router.getUrl("MemoryProject", { projectId }));
    },
    goToMemoryProjectComments: (projectId: Project["id"]): void => {
      navigate(router.getUrl("MemoryProjectComments", { projectId }));
    },
  };
}
